import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  FiEdit,
  FiMoreVertical,
  FiSearch,
  FiSlash,
  FiTrash2,
} from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  CardHeader,
  Table,
  Badge,
  Spinner,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  InputGroup,
  InputGroupText,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { getInventoryItems } from "../../../redux/inventory";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import PurchaseEntry from "./Purchase/Bills/PurchaseEntry";
import PaginatedList from "./PaginatedList";
import { formatDate } from "../../utils/dateFormatter";

const StockManagementPage = (props) => {
  const [stockModal, setStockModal] = useState(false);
const [selectedItem, setSelectedItem] = useState(null);
const [newStock, setNewStock] = useState("");


const toggleStockModal = () => setStockModal(!stockModal);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTip = () => setTooltipOpen(!tooltipOpen);
  const itemsList = useSelector((state) => state.inventory);
  const dispatch = useDispatch();
  const { itemsData, supplierData = [], purchaseData } = itemsList || {};
  const auth = useSelector((state) => state.authentication);
  const { userData } = auth;
  const [paginatedList, setPaginatedList] = useState([]);
  const [itemName, setItemName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [alertCount, setAlertCount] = useState("");
  const [formData, setFormData] = useState("");
  const [modal, setModal] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchInputByClick, setSearchInputByClick] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const navigate = useNavigate();
  const [customerDataDownload, setCustomerDataDownload] = useState("");
  const toggle = () => setModal(!modal);
  const [expiryAlertCount, setExpiryAlertCount] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [refresh, setRefresh] = useState(false);
  const branch = sessionStorage.getItem("branch")
    ? JSON.parse(sessionStorage.getItem("branch"))
    : "";
  const [token] = useState(
    userData ? userData.token : JSON.parse(sessionStorage.getItem("token"))
  );

  const oneMonthLater = new Date();
 
const openStockModal = (item) => {
  setSelectedItem(item);
  setNewStock(item.quantity || "");
  setStockModal(true);
};
  useEffect(() => {
    if (itemsList && itemsData.length) {
      setAlertCount(() => {
        let count = 0;
        itemsData.forEach((item) => {
          if (Number(item.quantity) <= Number(item.reorderPoint) + 1) {
            count++;
          }
        });
        return count;
      });
      setExpiryAlertCount(() => {
        let countX = 0;
        //   oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);

        itemsData.forEach((item) => {
          const expiryDate = new Date(item.expiry);
          //  expiryDate.setMonth(oneMonthLater.getMonth() + 1);
          // Check if expiry date is within one month from now
          if (expiryDate < oneMonthLater && item.quantity > 0) {
            countX++;
          }
        });
        return countX;
      });
    }

    if (itemsData && itemsData.length && supplierData && supplierData.length) {
      setCustomerDataDownload(() =>
        itemsData.map((item, id) => {
          return {
            SL_No: id + 1,
            Item: item.item,
            Brand: item.brandName,
            Price: item.unitPrice,
            MRP: item.mrp,
            Batch: item.batch,
            Expiry: item.expiry,
            HSN: item.hsn,
            Manufacturer: item.manufacturer,
            Quantity: item.quantity,
            Location: item.location,
            Category: item.category,
            Min_Stock: item.minStockLevel,
            Max_Stock: item.maxStockLevel,
            Reorder_Point: item.reorderPoint,
            Reorder_Qty: item.reorderQuantity,
            Supplier: supplierData.find(
              (sup) => sup.supplierId === item.supplierId
            )?.supplierName,
            Barcode: item.barcode,
            Notes: item.notes,
            ProductId: item.productId,
            Tax: item.tax,
          };
        })
      );
    }
    //   console.log(itemsList, supplierData);
  }, [itemsList, supplierData]);

  const exportToExcel = (data) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "my-file.xlsx");
  };

  const editInventoryHandler = (Data, toggle) => {
    setFormData(Data);
    toggle();
  };

  const deleteHandler = (item) => {
    const batch = prompt("Please enter the batch to confirm delete");
    if (batch && batch.toLocaleLowerCase() === item.batch.toLocaleLowerCase()) {
      {
        axios
          .post(
            `${process.env.REACT_APP_COLLEGE_ERP_API}add-items`,
            {
              item: item,
              date_removed: new Date(),
              status: "",
              removedBy: userData.user,
            },
            {
              params: { branch: userData.branch },
              headers: {
                Authorization: `Bearer ${userData.token}`,
              },
            }
          )
          .then((res) => {
            axios
              .delete(
                `${process.env.REACT_APP_COLLEGE_ERP_API}delete-inventory`,
                {
                  params: { id: item._id, branch: userData.branch },
                  headers: {
                    Authorization: `Bearer ${userData.token}`,
                  },
                }
              )
              .then((res) => {
                if (res) {
                  setRefresh(!refresh);
                  dispatch(
                    getInventoryItems({
                      token: userData.token,
                      branch: userData.branch,
                    })
                  );
                }
              })
              .catch((err) => {
                if (
                  (err.response.data &&
                    err.response.data.err &&
                    err.response.data.err.name === "TokenExpiredError") ||
                  err.response.data.message === "Unauthorized"
                ) {
                  navigate("/");
                  sessionStorage.removeItem("token");
                  sessionStorage.removeItem("srchData");
                  sessionStorage.removeItem("prescriptionHistory");
                  sessionStorage.removeItem("rights");
                  navigate("/cri-crm");
                  return err;
                }
              });
          });
      }
    } else if (batch) {
      alert("Batch not matching");
    }
  };

    const updateStock = () => {
    setShowModal(true);
    const postDataInventory = {
      quantity: Number(newStock.qty),
      user: userData.user,  
    };
    axios
      .post(
        `${process.env.REACT_APP_COLLEGE_ERP_API}update-inventory-qty-inc`,
        postDataInventory,
        {
          params: {
            branch: userData.branch,
            productId: newStock.productId,
          },
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          console.log("Inventory Updated");
          //  setShowModal(false);
          //  dispatch(
          //    getInventoryPurchase({
          //      token: userData.token,
          //      branch: userData.branch,
          //    })
          //  );
          // togglePurchaseEntry();
        }
      })

      .catch((err) => {
        console.log(err);
       // failedUpdates.push({ productId, quantity, error: err }); // Collect details of failed updates
      }).finally(() => {
        setShowModal(false);
        
        setRefresh(!refresh)
        toggleStockModal();
      });

  };

  return (
    <Container fluid className="p-0">
      <Row className="justify-content-center">
        <Col md="3" className="text-center">
          <h3>Stock Keeping Unit</h3>
        </Col>
      </Row>
      <Row>
        <Col md={2}>
          <Card className="m-3">
            <CardHeader>
              <Row className="d-flex justify-content-center">
                <h6>Stock Reorder Alert </h6>
                <Badge
                  color="warning"
                  style={{
                    width: "30px",
                    position: "absolute",
                    right: "-10px",
                    top: "-10px",
                  }}
                >
                  {alertCount}
                </Badge>{" "}
              </Row>
            </CardHeader>
          </Card>
        </Col>
        <Col md={3} className="pt-4">
          {" "}
          <InputGroup className="mb-4">
            <Input
              // color="primary"
              type="text"
              onChange={(e) => {
                setSearchInput(e.target.value)
                if (!e.target.value.trim()) {
                  setSearchInputByClick("");
                  setRefresh(() => !refresh);
                }
              }}
              placeholder="Search item"
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  setSearchInputByClick(searchInput);
                  if (!searchInput.trim()) {
                    setRefresh(() => !refresh);
                  }
                }
              }}
            />
            <InputGroupText
              onClick={() => {
                setSearchInputByClick(searchInput);
                if (!searchInput.trim()) {
                  setRefresh(() => !refresh);
                }
              }}
              style={{ cursor: "pointer" }}
            >
              {" "}
              Search
            </InputGroupText>
          </InputGroup>
        </Col>
        <Col md={5}>
          {" "}
          <FormGroup row>
            <Label for="supplier" md={2} className="fw-bold pt-4">
              Supplier
            </Label>
            <Col sm={5} md={5} className="pt-4">
              <Input
                className="custom-select-style"
                type="select"
                id="supplier"
                value={selectedSupplier || ""}
                onChange={(e) => setSelectedSupplier(e.target.value)}
              >
                <option value="">-- Select Supplier --</option>
                {(supplierData || []).map((sup) => (
                  <option key={sup.supplierId} value={sup.supplierId}>
                    {sup.supplierName}
                  </option>
                ))}
              </Input>
            </Col>
          </FormGroup>
        </Col>
        <Col className="pt-4" md={2}>
          <Button onClick={() => exportToExcel(customerDataDownload)}>
            Download
          </Button>
        </Col>
      </Row>

      <Row>
        <Col>
          <PaginatedList
            setPaginatedList={setPaginatedList}
            searchInput={searchInputByClick}
            selectedSupplier={selectedSupplier}
            setShowSpinner={setShowSpinner}
            endPoint="inventory-page"
            limit={100}
            refresh={refresh}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12} className="p-0">
          {(!paginatedList || showSpinner) && (
            <Spinner color="primary">
              <span></span>
            </Spinner>
          )}
          {paginatedList && !showSpinner && paginatedList.length && (
            <div className="table-container d-flex ms-0">
              <Table striped>
                <thead className="table-header">
                  <tr className="table-secondary">
                    <th>Sl No.</th>
                    <th style={{ width: "20%" }}>Item Name</th>
                    {
                      //<th>Brand Name</th>
                    }
                    <th>HSN/SAC</th>
                    <th>Unit</th>
                    <th>Unit Price</th>
                    <th>MRP</th>
                    <th>Quantity</th>
                    <th style={{ width: "5%" }}>Batch</th>
                    <th>Minimum Stock</th>
                    <th>Maximum Stock</th>
                    <th>Reorder Point</th>
                    <th>Expiry Date</th>

                    <th>Supplier</th>

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    // remove redudunt stocks display here
                  }
                  {paginatedList
                    //   .filter(
                    //     (item) =>
                    //       !searchInput ||
                    //       item.item
                    //         .toLowerCase()
                    //         .includes(searchInput.toLowerCase())
                    //   )
                    ?.map((item, id) => {
                      //   const expiryDate = new Date(item.expiry);
                      // const isExpiringSoon = expiryDate < oneMonthLater;

                      const itemClass =
                        Number(item.quantity) <= Number(item.reorderPoint) + 1
                          ? "table-warning"
                          : "";

                      if (item.item)
                        return (
                          <tr key={id} className={itemClass}>
                            <td>{id + 1}</td>
                            <td>{item.item}</td>
                            {
                              //<td>{item.brandName}</td>
                            }
                            <td>{item.hsn}</td>
                            <td>{item?.unit}</td>
                            <td>{item.unitPrice}</td>
                            <td>{item.mrp}</td>
                         <td
  style={{ cursor: "pointer", color: "#0d6efd", fontWeight: "500" }}
  onClick={() => openStockModal(item)}
>
  {item.quantity}
</td>
                            <td>{item.batch}</td>
                            <td>{item.minStockLevel}</td>
                            <td>{item.maxStockLevel}</td>
                            <td>{item.reorderPoint}</td>
                            <td>{formatDate(item.expiry)}</td>
                            {
                              <td>
                                {
                                  supplierData.find(
                                    (sup) => sup.supplierId === item.supplierId
                                  )?.supplierName
                                }
                              </td>
                            }
                            <td>
                              {(userData.rights === "Admin" ||
                                userData.rights === "Manager" ||
                                userData.rights === "Accounts") && (
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    tag="span"
                                    data-toggle="dropdown"
                                    aria-expanded={false}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <FiMoreVertical />
                                  </DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem
                                      onClick={() =>
                                        editInventoryHandler(item, toggle)
                                      }
                                    >
                                      <FiEdit color="green" className="me-2" />
                                      Edit
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => deleteHandler(item)}
                                    >
                                      <FiSlash color="red" className="me-2" />
                                      Remove
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              )}
                            </td>
                          </tr>
                        );
                    })}
                </tbody>
              </Table>
            </div>
          )}
        </Col>
      </Row>
      <Modal
        isOpen={modal}
        toggle={toggle}
        size="lg"
        style={{ maxWidth: "100%" }}
      >
        <ModalHeader toggle={toggle}>Edit Inventory</ModalHeader>
        <ModalBody>
          <PurchaseEntry
            editInventoryData={formData}
            setShowModal={setShowModal}
            togglePurchaseEntry={toggle}
            setSearchInputByClick={setSearchInputByClick}
            setRefresh={setRefresh}
            refresh={refresh}
            onlyInventoryAdd={true}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={showModal} centered>
        <ModalBody style={{ textAlign: "center", padding: "20px" }}>
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }}>
            <span></span>
          </Spinner>
          <p
            style={{ marginTop: "10px", fontSize: "16px", fontWeight: "bold" }}
          >
            Saving...
          </p>
        </ModalBody>
      </Modal>
      <Modal isOpen={stockModal} toggle={toggleStockModal}>
  <ModalHeader toggle={toggleStockModal}>
    Update Stock
  </ModalHeader>

  <ModalBody>
    {selectedItem && (
      <>
        <p>
          <strong>Item:</strong> {selectedItem.item}
        </p>

        <FormGroup>
          <Label>New Stock Quantity</Label>
          <Input
            type="number"
            value={newStock.qty}
            onChange={(e) => setNewStock({qty:e.target.value, productId: selectedItem.productId })}
          />
        </FormGroup>
      </>
    )}
  </ModalBody>

  <ModalFooter>
    <Button color="primary" onClick={updateStock}>
      Update
    </Button>

    <Button color="secondary" onClick={toggleStockModal}>
      Cancel
    </Button>
  </ModalFooter>
</Modal>
    </Container>
  );
};

export default StockManagementPage;
